export default __webpack_public_path__ + "img/save-pdf.e01670c0.svg";